module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "Dummy",
	"sourceName": "contracts/levels/Dummy.sol",
	"abi": [
		{
			"inputs": [],
			"name": "completed",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "bool",
					"name": "_completed",
					"type": "bool"
				}
			],
			"name": "setCompleted",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b5060c18061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80639d9a7fe9146037578063f51f4738146051575b600080fd5b603d606f565b604080519115158252519081900360200190f35b606d60048036036020811015606557600080fd5b503515156078565b005b60005460ff1681565b6000805460ff191691151591909117905556fea2646970667358221220f7959761f665934d518f2ceabd86ebbbbc2545eb74569e1030e5c646747e583664736f6c634300060c0033",
	"deployedBytecode": "0x6080604052348015600f57600080fd5b506004361060325760003560e01c80639d9a7fe9146037578063f51f4738146051575b600080fd5b603d606f565b604080519115158252519081900360200190f35b606d60048036036020811015606557600080fd5b503515156078565b005b60005460ff1681565b6000805460ff191691151591909117905556fea2646970667358221220f7959761f665934d518f2ceabd86ebbbbc2545eb74569e1030e5c646747e583664736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/Dummy.sol/Dummy.json
// module id = 1549
// module chunks = 0